/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, useState } from "react";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from "reactstrap";
import "./styles.scss";
import {
  sendVerificationCode,
  verify,
  changePassword,
  resetPassword,
  setPassword,
  logout,
} from "../../actions/usersActions";
import { verifyCode } from "../../actions/loginActions";
import Stepper from "react-stepper-horizontal";
import { Fade } from "reactstrap";
import InputVerificationCode from "../../components/InputVerificationCode";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import logo from "../../assets/img/brand/new-logo.png";
import InputEmail from "../../components/InputEmail";
import TimerComponent from "../../components/TimerComponent";
const ButtonLoader = require("reactstrap-button-loader").default;

class BlockedUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      password_repeat: "",
      phone: "",
      phone2: "",
      email: "",
      emailError: false,
      showErrorMessage: false,
      countryCode: "+90",
      verification_code: "",
      showModal: false,
      modalMessage: "",
      activeStep:
        this.props.location.step && this.props.location.step === "activation"
          ? 1
          : 0,
      verificationCodeValidityPeriod: undefined,
    };
  }

  toggleModal = (modalMessage) => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
      modalMessage,
    }));
  };

  changeCountryCode = (e) => {
    this.setState({ countryCode: e, phone2: this.state.phone });
  };

  /**
   * verification code request
   */
  onClickGetVerificationCode = (e) => {
    this.setState({ showErrorMessage: true });
    if (!this.state.emailError) {
      e.preventDefault();
      console.log(this.state.email);
      this.props
        .resetPassword(this.state.email)
        .then((res) => {
          this.setState({
            activeStep: 1,
            verificationCodeValidityPeriod: res.verificationCodeValidityPeriod,
          });
        })
        .catch((error) => {
          console.log("error", error);
          if (error.responseCode && error.responseCode === "E11") {
            this.toggleModal(this.props.t("blockedUser.phone_not_exists"));
          } else if (error.responseCode && error.responseCode === "E15") {
            this.toggleModal(this.props.t("blockedUser.request_expired"));
          } else {
            this.toggleModal(this.props.t("server_error"));
          }
        });
    }
  };

  /**
   * verification process
   */
  onClickVerification = (e) => {
    e.preventDefault();
    if (
      !this.state.verification_code.trim() ||
      this.state.verification_code.trim().length === 0 ||
      this.state.verification_code.indexOf("_") > -1
    ) {
      this.toggleModal(this.props.t("fill_alert"));
      return;
    }
    this.props
      .verifyCode({
        emailOrPhone: this.state.email,
        verificationCode: this.state.verification_code,
      })
      .then((res) => {
        localStorage.setItem("token", res.token);
        this.setState({ activeStep: 2 });
      })
      .catch((error) => {
        if (error.responseCode && error.responseCode === "E08") {
          this.toggleModal(this.props.t("blockedUser.verification_code_wrong"));
        } else if (
          error.message &&
          error.message === "INVALID_VERIFICATION_CODE"
        ) {
          this.toggleModal(this.props.t("blockedUser.verification_code_wrong"));
        } else if (
          error.message &&
          error.message === "VERIFICATION_CODE_EXPIRED"
        ) {
          this.toggleModal(
            this.props.t("blockedUser.verification_code_expired")
          );
        } else if (
          error.message &&
          error.message === "EXCEED_VERIFICATION_ATTEMPTS"
        ) {
          this.toggleModal(
            this.props.t("blockedUser.verification_exceed_attempts")
          );
        } else {
          this.toggleModal(this.props.t("server_error"));
        }
      });
  };

  /**
   * completes reset password process
   */
  onClickComplete = (e) => {
    e.preventDefault();
    if (
      this.state.password.trim().length === 0 ||
      this.state.password_repeat.trim().length === 0
    ) {
      this.toggleModal(this.props.t("fill_alert"));
      return;
    }

    if (this.state.password !== this.state.password_repeat) {
      this.toggleModal(this.props.t("blockedUser.passwords_not_match"));
      return;
    }

    this.props
      .setPassword({
        emailOrPhone: this.state.email,
        newPassword: this.state.password,
      })
      .then(() => {
        this.setState({ activeStep: 3 });
      })
      .catch((error) => {
        console.log("error", error);
        if (error.responseCode && error.responseCode === "E14") {
          this.toggleModal(this.props.t("blockedUser.change_password_error"));
        } else if (
          error.message &&
          error.message === "INVALID_PREVIOUS_PASSWORD"
        ) {
          this.toggleModal(this.props.t("blockedUser.password_same"));
        } else {
          this.toggleModal(this.props.t("server_error"));
        }
      });
  };

  /**
   * navigates to the login page
   */
  onClickLogin = (e) => {
    e.preventDefault();
    this.props.history.push("/login");
  };

  /**
   * when text in inputs change it pass text to the state
   */

  onChangeInputs = (e) => {
    this.setState({ [e.target.name]: e.target.value.trim() });
  };

  onChangeEmailError = (e) => {
    this.setState({ emailError: e });
  };

  /**
   * renders registration form elements
   */
  _renderForgetPasswordForm() {
    return (
      <Fade>
        <Form onSubmit={this.onClickGetVerificationCode}>
          <InputEmail
            setEmailError={this.onChangeEmailError}
            className="mb-4"
            placeholder={this.props.t("blockedUser.email_verification")}
            values={this.state.email}
            name="email"
            onChange={(e) => this.onChangeInputs(e)}
          />
          {this.state.showErrorMessage && this.state.emailError && (
            <Alert color="danger">
              <p className="mb-0">
                {this.props.t("blockedUser.email_regex_error")}
              </p>
            </Alert>
          )}
          <ButtonLoader
            color="success"
            block
            loading={this.props.loading}
            onClick={this.onClickGetVerificationCode}
          >
            {this.props.t("blockedUser.next_step")}
          </ButtonLoader>
        </Form>
      </Fade>
    );
  }

  /**
   * renders activation form elements
   */
  _renderActivationForm() {
    return (
      <Fade>
        <Form onSubmit={this.onClickVerification}>
          <Alert color="secondary">
            <p className="mb-0">
              {this.props.t("blockedUser.verification_message")}
            </p>
          </Alert>
          <InputVerificationCode
            name="verification_code"
            placeholder={this.props.t("blockedUser.verification_code")}
            onChange={(e) => this.onChangeInputs(e)}
          />
          {this.state.verificationCodeValidityPeriod && (
            <TimerComponent
              timerSeconds={this.state.verificationCodeValidityPeriod}
              timeoutText={"blockedUser.codeTimeOut"}
              remainingText={"blockedUser.remainingTime"}
              t={this.props.t}
            />
          )}
          <ButtonLoader
            color="success"
            block
            loading={this.props.loading}
            onClick={this.onClickVerification}
          >
            {this.props.t("blockedUser.next_step")}
          </ButtonLoader>
        </Form>
      </Fade>
    );
  }

  /**
   * renders set password form elements
   */
  _renderSetPasswordForm() {
    return (
      <Fade>
        <Form onSubmit={this.onClickComplete}>
          <InputGroup className="mb-3">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="icon-lock"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              name="password"
              type="password"
              placeholder={this.props.t("password")}
              autoComplete="ontime-password"
              onChange={this.onChangeInputs}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="icon-lock"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              name="password_repeat"
              type="password"
              placeholder={this.props.t("password_repeat")}
              autoComplete="ontime-password"
              onChange={this.onChangeInputs}
            />
          </InputGroup>
          <ButtonLoader
            color="success"
            block
            loading={this.props.loading}
            onClick={this.onClickComplete}
          >
            {this.props.t("blockedUser.change_password")}
          </ButtonLoader>
        </Form>
      </Fade>
    );
  }

  /**
   * renders success alert
   */
  _renderSuccessAlert() {
    return (
      <Alert color="success">
        <h4 className="alert-heading">{this.props.t("success")}</h4>
        <p> {this.props.t("blockedUser.change_password_success")} </p>
      </Alert>
    );
  }

  /**
   * renders stepper elements
   */
  _renderStepper() {
    return (
      <div className="stepper-wrapper">
        <Stepper
          steps={[
            { title: this.props.t("blockedUser.step_1") },
            { title: this.props.t("blockedUser.step_2") },
            { title: this.props.t("blockedUser.step_3") },
          ]}
          activeStep={this.state.activeStep}
          completeColor="#10BF65"
        />
      </div>
    );
  }

  /**
   * renders form container - card
   */
  _renderFormContainer() {
    return (
      <React.Fragment>
        <Fade>
          <Row className="justify-content-center">
            <Col xs="12" md="8" lg="6" className="logo-col">
              {/* <img src={ontime_logo} className="logo-ontime" /> */}
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs="12" md="8" lg="6">
              <CardGroup>
                <Card className="p-3">
                  <CardBody>
                    <center>
                      <img src={logo} height="100"></img>
                    </center>
                    &emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;
                    <center>
                      <h1>{this.props.t("blockedUser.title")}</h1>
                      {this.state.activeStep === 0 ? (
                        <p className="text-muted">
                          {this.props.t("blockedUser.subtitle")}.
                        </p>
                      ) : (
                        ""
                      )}
                    </center>
                    {this._renderStepper()}
                    {this.state.activeStep === 0
                      ? this._renderForgetPasswordForm()
                      : ""}
                    {this.state.activeStep === 1
                      ? this._renderActivationForm()
                      : ""}
                    {this.state.activeStep === 2
                      ? this._renderSetPasswordForm()
                      : ""}
                    {this.state.activeStep === 3
                      ? this._renderSuccessAlert()
                      : ""}
                  </CardBody>
                  <div>
                    <Button color="link" onClick={this.onClickLogin}>
                      &lt;&lt; {this.props.t("login.login")}
                    </Button>
                  </div>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Fade>
      </React.Fragment>
    );
  }

  /**
   * renders modal
   */
  _renderModal() {
    return (
      <Modal
        isOpen={this.state.showModal}
        modalTransition={{ timeout: 250 }}
        centered={true}
      >
        <ModalHeader>Oops..</ModalHeader>
        <ModalBody>{this.state.modalMessage}</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => this.toggleModal()}>
            {this.props.t("close")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  /**
   * React main render method
   */
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          {this._renderModal()}
          {this._renderFormContainer()}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loginReducer.loading,
  error: state.loginReducer.error,
  loading_project: state.projectReducer.loading,
});

const mapDispatchToProps = {
  verify,
  sendVerificationCode,
  changePassword,
  resetPassword,
  verifyCode,
  setPassword,
  logout,
};

export default compose(
  withTranslation("common"),
  connect(mapStateToProps, mapDispatchToProps)
)(BlockedUser);
